import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  isLoading: false,
  isGrouped: false,
  sessions: {},
};

function onLoadSessionsPast(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadSessionsPastSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: false,
    sessions: payload,
  };
}

function onLoadGroupSessionsPast(state) {
  return {
    ...state,
    isLoading: true,
  };
}

function onLoadGroupSessionsPastSuccess(state, { payload }) {
  return {
    ...state,
    isLoading: false,
    isGrouped: true,
    sessions: payload,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_REQUEST]: onLoadSessionsPast,
  [actions.LOAD_SUCCESS]: onLoadSessionsPastSuccess,
  [actions.LOAD_GROUP_REQUEST]: onLoadGroupSessionsPast,
  [actions.LOAD_GROUP_SUCCESS]: onLoadGroupSessionsPastSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
